import {Directive, forwardRef, Input} from '@angular/core';
import {
  AbstractControl,

  NG_VALIDATORS,

  ValidationErrors,
  Validator
} from '@angular/forms';

// type stsDyanmicValidatorDelegate = (control: AbstractControl) => ValidationErrors | null;

@Directive({
  selector: '[app-sts-username-email-validator][mode][modeDelegate]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => StsConditionalEmailValidatorDirective),
      multi: true
    }
  ]
})
export class StsConditionalEmailValidatorDirective implements Validator {

  @Input('mode') mode = '';
  @Input('modeDelegate') modeDelegate: () => string;

  constructor() { }

  validate(control: AbstractControl): ValidationErrors | null  {
    if (this.mode !== this.modeDelegate()) { return null; }
    let obj = {};
    obj[this.mode] = true;
    return control.value !== '' ? null : obj;
  }

}


export function __usernameOrEmail(mode: string, modeDelegate: () => string): (_: AbstractControl) => ValidationErrors {

  let tmp = (control: AbstractControl): ValidationErrors | null => {
    // console.log(control, mode, modeDelegate());
    if (mode !== modeDelegate()) {
      // console.log('not required => ', control);
      return null;
    }
    let obj = {};
    obj[mode] = true;
    let rst = control.value !== '' ? null : obj;
    console.log('not required => ', rst);
    return rst;
  };

  return tmp;

}
